<main class="ui-auth-login">
  <section class="ui-auth-login__panel">
    <img class="ui-auth-login__logo" [src]="logoSrc()" [alt]="logoAlt()" />
    <h1 class="ui-auth-login__title">Sistema de Gestión Integral</h1>

    <form
      class="ui-auth-login__form"
      (submit)="$event.preventDefault(); onSubmit()"
    >
      <div class="ui-auth-login__row ui-auth-login__row--username">
        <ui-input
          label="Correo electrónico"
          kind="email"
          [required]="true"
          [showOptionalHint]="false"
          placeholder="correo@ejemplo.com"
          autocomplete="email"
          [maxlength]="365"
          [value]="username()"
          (valueChange)="username.set($event)"
          [invalid]="usernameInvalid()"
          [message]="usernameMessage()"
        />
      </div>

      <div class="ui-auth-login__row ui-auth-login__row--password">
        <ui-input
          label="Contraseña"
          kind="password"
          [required]="true"
          [showOptionalHint]="false"
          placeholder="Contraseña"
          autocomplete="current-password"
          [minlength]="6"
          [maxlength]="200"
          [value]="password()"
          (valueChange)="password.set($event)"
          [invalid]="passwordInvalid()"
          [message]="passwordMessage()"
        />
      </div>

      <div class="ui-auth-login__row ui-auth-login__row--captcha">
        <ui-recaptcha
          [siteKey]="recaptchaSiteKey()"
          [theme]="recaptchaTheme()"
          [size]="recaptchaSize()"
          [language]="recaptchaLanguage()"
          [fluid]="true"
          [fitChallengeToViewport]="true"
          (resolved)="onCaptchaResolved($event)"
          (expired)="onCaptchaExpired()"
          (errored)="onCaptchaError()"
        />
        @if (captchaMessage()) {
          <ui-message
            class="ui-auth-login__captcha-message"
            variant="error"
            [message]="captchaMessage()"
            [noMarginBottom]="true"
          />
        }
      </div>

      <div class="ui-auth-login__row ui-auth-login__row--submit">
        <ui-button
          class="ui-auth-login__action-button"
          type="submit"
          variant="primary"
          size="md"
          [block]="true"
          [disabled]="!canSubmit()"
        >
          Ingresar
        </ui-button>
      </div>

      <div class="ui-auth-login__row">
        <ui-button
          class="ui-auth-login__action-button"
          type="button"
          variant="ghost"
          size="md"
          [block]="true"
          (pressed)="forgotPassword.emit()"
        >
          Recuperar contraseña
        </ui-button>
      </div>
    </form>
  </section>
</main>
